import actionTypes from 'Modules/Shop/actions/types';

export const INITIAL_STATE = {
  isLoading: false,
  informations: {},
  screenIndex: 1,
};

export function paymentInformations(state = INITIAL_STATE, action = {}) {
  const { type, payload } = action;

  if (type === actionTypes.GET_PAYMENT_INFORMATION_REQUEST) {
    return {
      ...state,
      isLoading: true,
      informations: {
        ...state.informations,
        currencyChanged: false,
      },
    };
  }
  if (type === actionTypes.GET_PAYMENT_INFORMATION_SUCCESS) {
    return {
      ...state,
      isLoading: false,
      informations: {
        ...payload.data,
        currencyChanged:
          !!state.informations.currency && payload.data.currency !== state.informations.currency,
      },
    };
  }
  if (type === actionTypes.GET_PAYMENT_INFORMATION_FAILURE) {
    return {
      ...state,
      isLoading: false,
      informations: {
        ...state.informations,
        promotion: {
          networkError: true,
        },
        currencyChanged: false,
      },
    };
  }

  if (type === actionTypes.SET_PAYMENT_SCREEN) {
    return {
      ...state,
      screenIndex: payload.screen,
    };
  }
  return state;
}

export default paymentInformations;
